import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { AuthenticationProvider } from './context/authenticationContext';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <AuthenticationProvider>
      <App />
    </AuthenticationProvider>
  </React.StrictMode>,
  document.getElementById('wrapper')
);
